function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { transparentize } from 'polished';
import { Input, KEYBOARD_KEYS, Label, MousePositionedTooltip } from '@keen.io/ui-core';
import { BodyText, FontWeight } from '@keen.io/typography';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { InputContainer, QueryIcon, UseQueryName } from './HeadingSettings.styles';
import SectionTitle from '../SectionTitle';
import SettingsContainer from '../SettingsContainer';
import FieldGroup from '../FieldGroup';
import { AppContext } from '../../contexts';

var HeadingSettings = function HeadingSettings(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      onUpdateTitleSettings = _ref.onUpdateTitleSettings,
      onUpdateSubtitleSettings = _ref.onUpdateSubtitleSettings,
      settingsDisabled = _ref.settingsDisabled,
      savedQueryName = _ref.savedQueryName;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var titleInput = useRef(null);

  var handleQueryNameClick = function handleQueryNameClick() {
    onUpdateTitleSettings(_objectSpread(_objectSpread({}, title), {}, {
      content: savedQueryName
    }));

    if (titleInput.current) {
      titleInput.current.value = savedQueryName;
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(SectionTitle, {
    title: t('widget_customization_heading_settings.section_title'),
    description: t('widget_customization_heading_settings.section_description')
  }), React.createElement(MousePositionedTooltip, {
    isActive: !!settingsDisabled,
    tooltipPortal: modalContainer,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.white[500]
      }, settingsDisabled);
    }
  }, React.createElement(SettingsContainer, {
    isDisabled: !!settingsDisabled
  }, savedQueryName && React.createElement(MousePositionedTooltip, {
    isActive: !!savedQueryName,
    tooltipPortal: modalContainer,
    tooltipTheme: "light",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.black[100]
      }, t('widget_customization_heading_settings.saved_query_name_tooltip'));
    }
  }, React.createElement(UseQueryName, {
    "data-testid": "inherit-query-name",
    onClick: handleQueryNameClick,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) handleQueryNameClick();
    },
    role: "button",
    tabIndex: 0
  }, React.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400
  }, React.createElement(FontWeight, {
    fontWeight: 700
  }, t('widget_customization_heading_settings.saved_query_name_label'), ' '), savedQueryName), React.createElement(QueryIcon, null, React.createElement(Icon, {
    type: "share",
    width: 14,
    height: 14,
    fill: transparentize(0.5, colors.black[100])
  })))), React.createElement(FieldGroup, null, React.createElement(Label, {
    variant: "secondary"
  }, t('widget_customization_heading_settings.title_label')), React.createElement(InputContainer, null, React.createElement(Input, {
    ref: titleInput,
    defaultValue: title.content,
    placeholder: t('widget_customization_heading_settings.title_placeholder'),
    variant: "solid",
    onChange: function onChange(e) {
      return onUpdateTitleSettings(_objectSpread(_objectSpread({}, title), {}, {
        content: e.currentTarget.value
      }));
    }
  }))), React.createElement(FieldGroup, null, React.createElement(Label, {
    variant: "secondary"
  }, t('widget_customization_heading_settings.subtitle_label')), React.createElement(InputContainer, null, React.createElement(Input, {
    defaultValue: subtitle.content,
    placeholder: t('widget_customization_heading_settings.subtitle_placeholder'),
    variant: "solid",
    onChange: function onChange(e) {
      return onUpdateSubtitleSettings(_objectSpread(_objectSpread({}, subtitle), {}, {
        content: e.currentTarget.value
      }));
    }
  }))))));
};

export default HeadingSettings;